import { render, staticRenderFns } from "./Privilege.vue?vue&type=template&id=69b3892e&scoped=true&"
import script from "./Privilege.vue?vue&type=script&lang=js&"
export * from "./Privilege.vue?vue&type=script&lang=js&"
import style0 from "./Privilege.vue?vue&type=style&index=0&id=69b3892e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b3892e",
  null
  
)

export default component.exports